// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"m4-z"};